import { createFileRoute } from '@tanstack/react-router'
import { WITNESS_ELIGIBLE_ROLES } from '@workspace/utils'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { WitnessRequestPage } from '@/features/medication-register/witness-request-page'

/** Confirm or decline one line as its witness (S8 Task 12). Same roles as the list. */
export const Route = createFileRoute(
  '/_authenticated/_organization/medication-witness/$entryId'
)({
  beforeLoad: async () => {
    await requireRoles([...WITNESS_ELIGIBLE_ROLES])
    await requireActiveSubscription()
  },
  component: WitnessRequestPage,
})
